var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.614 9.588a64.903 64.903 0 0 0-1.338-.646c-.162-.069-.315-.1-.447.101a9.732 9.732 0 0 1-.629.776c-.114.135-.23.147-.426.051a5.43 5.43 0 0 1-1.594-.982 6.07 6.07 0 0 1-1.106-1.372.294.294 0 0 1-.042-.216.283.283 0 0 1 .122-.182c.09-.091.196-.233.296-.337a1.43 1.43 0 0 0 .2-.334.356.356 0 0 0 0-.334c-.053-.098-.448-1.075-.61-1.473-.162-.398-.335-.334-.449-.334h-.378a.726.726 0 0 0-.527.246 2.212 2.212 0 0 0-.693 1.652c0 .983.706 1.918.805 2.053.098.135 1.4 2.131 3.386 2.991.37.157.737.297 1.133.417.403.123.83.15 1.246.079.381-.059 1.171-.491 1.338-.941a1.62 1.62 0 0 0 .091-.984c-.05-.084-.182-.133-.378-.231M7.996 0A7.925 7.925 0 0 0 2.39 2.321a7.93 7.93 0 0 0-1.265 9.571L0 16l4.208-1.1a7.887 7.887 0 0 0 3.776.963H8a7.935 7.935 0 0 0 7.658-5.88 7.935 7.935 0 0 0-3.695-8.92A7.935 7.935 0 0 0 7.997 0m0 1.2c1.18 0 2.344.312 3.366.902a6.762 6.762 0 0 1 2.851 3.253 6.766 6.766 0 0 1 .284 4.317 6.77 6.77 0 0 1-2.402 3.598 6.78 6.78 0 0 1-4.112 1.393 6.705 6.705 0 0 1-3.2-.817l-.418-.227-.46.12-2.2.575.577-2.105.131-.483-.25-.433a6.768 6.768 0 0 1-.842-4.244A6.774 6.774 0 0 1 3.24 3.17 6.763 6.763 0 0 1 7.997 1.2",
    id: "path-2c2c6006-fb2d-4c26-9cef-98f8c1229976"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Social-media-/-whatsApp"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2c2c6006-fb2d-4c26-9cef-98f8c1229976",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2c2c6006-fb2d-4c26-9cef-98f8c1229976"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#53BA63",
    xlinkHref: "#path-2c2c6006-fb2d-4c26-9cef-98f8c1229976"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.f9126731e97dda9da82fc59e6a508971.svg";
export { ForwardRef as ReactComponent };